// @flow
const  blues = {
   blue_1: '#0095d1'
};

export default {
   primary: blues.blue_1,
};
